import baseApi from "@/api/baseApi";
export default {
  addOrUpdate(context, form) {
    return baseApi.post(`/api-piglet/api/article/${context}/v1`, form)
  },
  fetchAll(context) {
    return baseApi.get(`/api-piglet/api/article/${context}/v1`)
  },
  remove(context, id) {
    return baseApi.delete(`/api-piglet/api/article/${context}/${id}/v1`)
  }
}
